import styled from 'styled-components';
import {DIMENSION} from '../../constants';

export const CommentListContainer = styled.div`
  margin-bottom: ${DIMENSION.MARGIN_DEFAULT}px;
  max-height: 335px;
  overflow-y: auto;
`;